import api from "../../utils/api";

const baseEndpoint = process.env.REACT_APP_API_BASE_URL
    ? process.env.REACT_APP_API_BASE_URL
    : "";
export const baseAPI = api(baseEndpoint);

const utilsService = {
    getStates: async () => {
        return baseAPI.get(`/Util/GetStates`);
    },

    getmytransfer: async (payload:any) => {
        return baseAPI.get('/v2/SelfServices/getmytransfer', {
            params: {
              PageNumber: payload?.PageNumber,
              PerSize: payload?.PageSize,
            },
          });
    },


    
    getCountries: async () => {
        return baseAPI.get(`/v2/SelfServices/country`);
    },
    getLGA: async (data: any) => {
        return baseAPI.post(`/Util/GetLga`, data);
    },
    getRelationshipOfficerDetails: async () => {
        return baseAPI.get(`/util/GetRelationshipOfficerDetails`);
    },
    getTeams: async () => {
        return baseAPI.get(`/v2/SelfServices/getteams`);
    },
    
};
export default utilsService;
